var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout text-center"},[_c('h1',{staticClass:"dashboard-title"},[_vm._v("Welcome to the Admin Dashboard")])])}]

export { render, staticRenderFns }